<template>
  <div class="range-input">
    <div class="range-slot">
      <slot name="from"></slot>
    </div>
    <div class="range-slot">
      <slot name="to"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RangeInput',
}
</script>

<style scoped>
.range-input {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
}

.range-slot {
  flex: 1;
  min-width: 0;
}

.range-arrow {
  color: #999;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
</style>
